import React from 'react';
import { motion } from 'framer-motion';
import { ChevronLeft, ChevronRight, Calendar } from 'lucide-react';

const DateNavigator = ({ selectedDate, onDateChange }) => {
  const getDates = () => {
    const dates = [];
    const today = new Date();
    
    for (let i = -3; i <= 3; i++) {
      const date = new Date(today);
      date.setDate(today.getDate() + i);
      dates.push(date);
    }
    
    return dates;
  };

  const formatDate = (date) => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    if (date.toDateString() === today.toDateString()) {
      return 'Hari Ini';
    } else if (date.toDateString() === tomorrow.toDateString()) {
      return 'Besok';
    } else if (date.toDateString() === yesterday.toDateString()) {
      return 'Kemarin';
    } else {
      return date.toLocaleDateString('id-ID', { weekday: 'short', day: 'numeric', month: 'short' });
    }
  };

  const isToday = (date) => {
    const today = new Date();
    return date.toDateString() === today.toDateString();
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.1 }}
      className="glass-card p-6 mb-8"
    >
      <div className="flex items-center justify-between">
        <motion.button
          whileHover={{ scale: 1.1, x: -5 }}
          whileTap={{ scale: 0.9 }}
          onClick={() => {
            const newDate = new Date(selectedDate);
            newDate.setDate(selectedDate.getDate() - 1);
            onDateChange(newDate);
          }}
          className="p-2 rounded-full hover:bg-white/10 transition-colors"
        >
          <ChevronLeft className="w-6 h-6 text-white/80" />
        </motion.button>

        <div className="flex-1 flex justify-center space-x-2 overflow-x-auto px-4">
          {getDates().map((date, index) => (
            <motion.button
              key={date.toDateString()}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ scale: 1.05, y: -2 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => onDateChange(date)}
              className={`flex flex-col items-center p-3 min-w-[80px] rounded-xl transition-all duration-300 ${
                date.toDateString() === selectedDate.toDateString()
                  ? 'bg-gradient-to-r from-football-green-500 to-football-green-600 text-white shadow-lg'
                  : isToday(date)
                  ? 'bg-football-green-500/20 text-white border border-football-green-500'
                  : 'hover:bg-white/10 text-white/80'
              }`}
            >
              <span className="text-xs font-medium mb-1">
                {date.toLocaleDateString('id-ID', { weekday: 'short' })}
              </span>
              <span className="text-lg font-bold">
                {date.getDate()}
              </span>
              <span className="text-xs">
                {date.toLocaleDateString('id-ID', { month: 'short' })}
              </span>
              {isToday(date) && (
                <motion.div
                  animate={{ scale: [1, 1.2, 1] }}
                  transition={{ duration: 1, repeat: Infinity }}
                  className="mt-1 w-1 h-1 bg-football-green-400 rounded-full"
                />
              )}
            </motion.button>
          ))}
        </div>

        <motion.button
          whileHover={{ scale: 1.1, x: 5 }}
          whileTap={{ scale: 0.9 }}
          onClick={() => {
            const newDate = new Date(selectedDate);
            newDate.setDate(selectedDate.getDate() + 1);
            onDateChange(newDate);
          }}
          className="p-2 rounded-full hover:bg-white/10 transition-colors"
        >
          <ChevronRight className="w-6 h-6 text-white/80" />
        </motion.button>
      </div>
    </motion.div>
  );
};

export default DateNavigator;
